import polyglotI18nProvider from 'ra-i18n-polyglot';
import ukrainianMessages from 'ra-language-ukrainian';

const customUkrainianMessages = {
    ...ukrainianMessages,
    ra: {
        ...ukrainianMessages.ra,
        sort: {
            ...ukrainianMessages.ra.sort,
            sort_by: 'Сортувати: %{field}, %{order}',
            ASC: 'за зростанням',
            DESC: 'за спаданням'
        },
        navigation: {
            ...ukrainianMessages.ra.navigation,
            page_rows_per_page: 'Кількість рядків на сторінці',
            page_range_info: '%{offsetBegin}-%{offsetEnd} із %{total} записів'
        }
    }
};

const i18nProvider = polyglotI18nProvider(() => customUkrainianMessages, 'ua', [{ locale: 'ua', name: 'Ukrainian' }], {
    allowMissing: true
});

export default i18nProvider;
